class EmailVerification {
  constructor(options) {
    this.current = 0
    this.box = null
    this.boxItemArr = []
    // 是否验证过？
    this.emailStatus = localStorage.getItem('emailStatus') || false


    this.init()
    this.initShowBox()
    this.step1BtnEvent()
    this.sendingEmail()
  }

  // 初始化内容
  init() {
    this.box = document.querySelector('#email-verification')
    this.boxItemArr = document.querySelectorAll('.verification-box')
    const urlArr = location.search.slice(1, -1).replaceAll('&', '=').split('=')
    const obj = {}
    urlArr.forEach((i, index) => {
      if (index % 2 === 0) {
        obj[i] = urlArr[index + 1]
      }
    })
    if (obj && obj.code) {
      this.current = 3
    } else {
      this.current = this.emailStatus ? 3 : 0
    }
  }

  initShowBox() {
    if (!this.boxItemArr.length) {
      this.init()
    }
    $(this.boxItemArr[this.current]).show()
  }


  // 下一步显示
  step1BtnEvent() {
    const step1Btn = this.box.querySelector('.step1-btn')
    step1Btn.addEventListener('click', () => {
      $(this.boxItemArr[this.current]).hide()

      this.current = 1
      this.initShowBox()
    })

    const editForm = this.box.querySelector('.edit-form')
    editForm.addEventListener('click', () => {
      $(this.boxItemArr[this.current]).hide()

      this.current = 1
      this.initShowBox()
    })


    const step3Btn = this.box.querySelectorAll('.instead')
    step3Btn.forEach(i => {
    i.addEventListener('click', () => {
        $(this.boxItemArr[this.current]).hide()
        this.current = 4
        this.initShowBox()
      })
    })

    const stepBack = this.box.querySelector('.step5-back')
    stepBack.addEventListener('click', () => {
      $(this.boxItemArr[this.current]).hide()

      this.current = 1
      this.initShowBox()
    })

    let clipboard = new ClipboardJS('.copy-server-email')
    clipboard.on('success', (e) => {
      e.clearSelection();
      $('.step5-Copied').show()
      setTimeout(() => {
        $('.step5-Copied').hide()
      }, 3000)
    })

    let clipboard1 = new ClipboardJS('.copy-code-code')
    clipboard1.on('success', (e) => {
      e.clearSelection();
      $('.copy-code--Copied').show()
      setTimeout(() => {
        $('.copy-code--Copied').hide()
      }, 3000)
    })


  }

  // 发送邮件
  sendingEmail() {
    const form = this.box.querySelector('form[name="customEmailName"]')
    if (!form) return false
    form.addEventListener('click', () => {
      let _this = this
      setTimeout(() => {
        form.onsubmit = function () {
          return _this.senEmail(form);
        }
      }, 100)
    })
  }

  senEmail (form) {
    let f = new FormData(form)
    let studentEmail = f.get('contact[email]')
    if (!studentEmail) {
      return false
    }
    const c = /^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+edu|ac.uk|sch.uk$/i;
    if (!(c.test(studentEmail))) {
      $('.step2-email-error').show()
      setTimeout(() => {
        $('.step2-email-error').hide()
      }, 3000)
      return false
    } else {
       gtag("event", "stuform_submit", {
        event_name: "form_submit",
        event_category: "form_submission",
        event_label: "contact_form",
        non_interaction: false,
        value: new Date().getTime(),
        send_to: 'GA4'
      })
      $('.step2-email-error').hide()
      localStorage.setItem('emailStatus', 'true')
      setTimeout(() => {
        window.Shopify.recaptchaV3.addToken(form, 'customer');
      }, 200)
      return false
    }
  }
}


